import { useDispatch, useSelector } from 'react-redux';
import { useActionCreators } from '../../../../../../../shared';
import { privateTemplateModuleTagAPI } from '../../../../../../../entities/module/private-template-module-tag/api/api';
import {
	templateModuleTagGroupActions,
	templateModuleTagGroupSelectors,
// eslint-disable-next-line max-len
} from '../../../../../../../entities/template/private-template-tag-group/template-tag-group/model/template/slice/privateTemplateModuleTagGroupSlice';
import { notificationError, notificationSuccess } from '../../../../../../Notifications/callNotifcation';
import { privateTemplateModuleTagGroupAPI } from '../../../../../../../entities/template/private-template-tag-group/template-tag-group/api/privateTemplateModuleTagGroupAPI';
import { useSelectedGroupTags } from './useSelectedGroupTags';

export const useDeleteTagGroup = () => {
	const dispatch = useDispatch();

	const [deleteTagGroup] = privateTemplateModuleTagGroupAPI.useDeleteMutation();

	const deletingTagGroupId = useSelector(templateModuleTagGroupSelectors.getDeletingGroupId);

	const actions = useActionCreators(templateModuleTagGroupActions);
	const handleDeletingModal = (value: boolean) => dispatch(actions.setIsDeleteGroupModalActive(value));

	const { onCleanSelectedGroupTags } = useSelectedGroupTags();

	const onDeleteGroup = async () => {
		if (deletingTagGroupId) {
			try {
				await deleteTagGroup({ id: deletingTagGroupId })
					.unwrap();
				handleDeletingModal(false);
				onCleanSelectedGroupTags(deletingTagGroupId.toString());
				notificationSuccess('Группа успешно удалена');

				dispatch(privateTemplateModuleTagGroupAPI.util?.invalidateTags(['tag_group']));
				dispatch(privateTemplateModuleTagAPI.util?.invalidateTags(['tag']));
			} catch (e) {
				notificationError('Возникла ошибка при удалении группы тегов...');
			}
		}
	};

	return {
		onDeleteGroup,
		handleDeletingModal,
	};
};
